import { useIsMobile } from './useIsMobile';

/**
 * Whether an input should auto-focus, suppressed on mobile.
 *
 * Auto-focusing an input inside a modal / bottom-sheet on mobile pops the
 * on-screen keyboard the instant it opens, which shifts the layout and covers
 * content. Desktop has no such cost, so it keeps the auto-focus.
 *
 * Compose with any caller-specific intent externally so the caller's condition
 * stays visible at the call site:
 *
 *   <input autoFocus={useDesktopAutoFocus()} />
 *   <input autoFocus={autoFocusOnDesktop && editingId === entry.id} />
 *
 * Do NOT use for surfaces where focusing IS the point (search/filter inputs the
 * user opened specifically to type into) or full-page forms (auth), where the
 * keyboard appearing is expected rather than disruptive.
 */
export function useDesktopAutoFocus(): boolean {
  return !useIsMobile();
}
